import {createLocalizationContext} from "@variocube/app-ui";
import * as React from "react";

type HostPlusCubeUi = typeof import("./en.json") & typeof import("@variocube/cube-ui/lib/i18n/en.json");

export const {LocalizationProvider, useLocalization} = createLocalizationContext<HostPlusCubeUi>({
    load: async (lang: string) => ({
        ...await import(`@variocube/cube-ui/lib/i18n/${lang}.json`),
        ...await import(`./${lang}.json`),
    }),
    fallback: "en",
});

export const SUPPORTED_LANGUAGES: string[] = ["en", "de", "et", "fr", "it", "cs", "pl", "sv", "tr", "no"];
export const LANGUAGE_NAMES: Record<string, string> = {};

async function initLanguageNames() {
    for (const lang of SUPPORTED_LANGUAGES) {
        LANGUAGE_NAMES[lang] = (await import(`./${lang}.json`)).LanguageName;
    }
}

await initLanguageNames();